import { render, staticRenderFns } from "./MsPopup.vue?vue&type=template&id=746e3f7d&scoped=true"
import script from "./MsPopup.vue?vue&type=script&lang=js"
export * from "./MsPopup.vue?vue&type=script&lang=js"
import style0 from "./MsPopup.vue?vue&type=style&index=0&id=746e3f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e3f7d",
  null
  
)

export default component.exports